'use client'

import { openLogin } from '@/components/auth/open-auth'
import { HomeContainer } from '@/components/common'
import { Button } from '@/components/ui/button'
import { ImageHelper } from '@/lib/helpers/image.helper'
import { useTranslations } from 'next-intl'
import Image from 'next/image'

interface BannerClubProps {
  isLogin: boolean
}

export const BannerClub = ({ isLogin }: BannerClubProps) => {
  const t = useTranslations()
  const bannerImages = isLogin
    ? {
        desktop: '/image/January2025/mceclip0_54.png',
        mobile: '/image/January2025/mceclip2_58.jpg',
      }
    : {
        desktop: '/image/January2025/mceclip0_54.png',
        mobile: '/image/April2025/mceclip0_77.jpg',
      }

  return (
    <HomeContainer className='px-0'>
      <div className='relative'>
        <picture className='w-full'>
          <source
            media='(max-width: 768px)'
            srcSet={ImageHelper.getImageUrl(bannerImages.mobile)}
          />
          <Image
            src={ImageHelper.getImageUrl(bannerImages.desktop)}
            alt='Coolclub banner'
            width={1000}
            height={1000}
            className='w-full'
          />
        </picture>

        {!isLogin && (
          <Button
            className='absolute bottom-[12%] left-[6%] uppercase'
            variant={'black'}
            ga-tracking-value='coolclub-landing__join-now-banner'
            ga-tracking-label={t('landing_coolclub_page.banner.join_now')}
            onClick={() => {
              openLogin()
            }}
          >
            {t('landing_coolclub_page.banner.join_now')}
            <Image
              src='/icons/icon-arrow-line-right.svg'
              width={15}
              height={16}
              alt='Arrow right'
              loading='lazy'
              decoding='async'
              className='transition-transform duration-200 group-hover:translate-x-1'
            />
          </Button>
        )}
      </div>
    </HomeContainer>
  )
}
